import React from "react";
import { StoriesPageTemplate } from "themes/application/categories/pages";
import { StoriesViewStore } from "application/categories/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView((rootStore, componentProps) => new StoriesViewStore(rootStore, componentProps), "storiesViewStore")
class StoriesPage extends React.Component {
    render() {
        return <StoriesPageTemplate {...this.props} />;
    }
}

export default StoriesPage;
